import React from "react";
import IconGlyph from "@/bit/components/components.icon-glyph";
import styles from "./styles";

const PillWithIconFake = ({ border , noArrow=false}) => {
  return (
    <>
      <div
        className={`pill-with-icon-fake ${
          border ? "pill-with-icon-fake--border" : ""
        }`}
      >
        <div className="pill-with-icon-fake--content">
          <div className="pill-with-icon-fake--data">
            <div className="pill-with-icon-fake--data--title">
              <div className="skeleton pill-with-icon-fake--data--title--bar" />
            </div>
            <div className="pill-with-icon-fake--data--subtitle">
              <div className="skeleton pill-with-icon-fake--data--subtitle--bar" />
            </div>
          </div>
        </div>
        {!noArrow && (
          <IconGlyph id="cheuron-right-m" height="12px" color="movistarBlue" />
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default PillWithIconFake;
